import React from 'react';
import './QuestionNavigator.css';

// Like QuestionNavigator, but grouped by section and — matching the real
// UCAT ANZ rule that a section is locked as soon as you leave it — only
// the current section's questions are clickable. Past sections are shown
// dimmed with a lock icon so the student can still see their shape.
function SectionedNavigator({ sections, sectionIndex, questionIndex, answers, flagged, onJump, onClose }) {
  return (
    <div className="navigator-overlay" onClick={onClose}>
      <div className="navigator" onClick={(e) => e.stopPropagation()}>
        <div className="navigator-header">
          <span>Question Navigator</span>
          <button className="navigator-close" onClick={onClose} aria-label="Close navigator">×</button>
        </div>
        <div className="navigator-legend">
          <span><i className="navigator-dot navigator-dot-answered" /> Answered</span>
          <span><i className="navigator-dot navigator-dot-flagged" /> Flagged</span>
          <span><i className="navigator-dot navigator-dot-current" /> Current</span>
        </div>
        <div className="navigator-sections">
          {sections.map((section, sIdx) => {
            const isCurrentSection = sIdx === sectionIndex;
            const isPastSection = sIdx < sectionIndex;
            return (
              <div key={section.code} className="navigator-section-block">
                <div className="navigator-section-title">
                  {section.name}
                  {isPastSection && <span className="navigator-section-locked"> 🔒 Locked</span>}
                  {isCurrentSection && <span className="navigator-section-current-tag"> Current</span>}
                </div>
                <div className="navigator-grid">
                  {section.questions.map((q, qIdx) => {
                    const isAnswered = Boolean(answers[q.id]);
                    const isFlagged = Boolean(flagged[q.id]);
                    const isCurrent = isCurrentSection && qIdx === questionIndex;
                    const clickable = isCurrentSection;
                    return (
                      <button
                        key={q.id}
                        disabled={!clickable}
                        className={[
                          'navigator-cell',
                          isCurrent ? 'navigator-cell-current' : '',
                          isAnswered ? 'navigator-cell-answered' : '',
                          isFlagged ? 'navigator-cell-flagged' : '',
                          !clickable ? 'navigator-cell-disabled' : '',
                        ].join(' ').trim()}
                        onClick={() => {
                          if (!clickable) return;
                          onJump(sIdx, qIdx);
                          onClose();
                        }}
                        title={`${section.name} — Question ${qIdx + 1}${isFlagged ? ' (flagged)' : ''}${isAnswered ? ' (answered)' : ''}`}
                      >
                        {qIdx + 1}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default SectionedNavigator;
